/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { get } from 'lodash'

/**
 *     Import
 *     - Components
 */

import Variation from './Variation'
import NewVariation from '../../Step05/components/NewVariation'
import NewRateVariation from './NewRateVariation'
import RateVariation from './RateVariation'
import PopUp from '../../../../common/PopUp/PopUp'

interface TradeFairLocation {
    id: number
    title: string
}

interface Props {
    fetchTradeFairsLocations: () => void
    tradeFairsLocations: {
        data: TradeFairLocation[]
    }
}

/**
 *     Step main container
 */
export default class VariantionContainer extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            requestQuote: false,
            addQuotePopupError: false,
            addQuoteError: '',
            tradeFairsLocList: [],
        }
    }

    componentDidMount() {
        this.props.fetchTradeFairsLocations()
    }

    componentWillMount() {
        if (this.props.editRenewal) {
            this.props.getRenewalVariation(this.props.quoteId)
        } else {
            this.props.getQuoteVariation(this.props.quoteId)
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        const { tradeFairsLocations: { data: prevData = [] } } = prevProps
        const { tradeFairsLocations: { data = [] } } = this.props

        if (prevData !== data) {
            let list: { value: number; text: string }[] = []
            if (data.length > 0) {
                list = data.map((loc: TradeFairLocation) => ({
                    value: loc.id,
                    text: loc.title,
                }))
            }
            list.push({ value: 0, text: 'other' })
            this.setState({
                tradeFairsLocList: list,
            })
        }
    }

    componentWillUnmount() {
        this.props.step05.response = null
    }
    reqVariation = () => {
        this.setState({ requestQuote: false })
    }

    /**
     * Handle create New Variation click
     */
    createNewVariation = (reqQuote = false) => {
        if (reqQuote) {
            this.setState({ requestQuote: reqQuote })
        }

        this.props.createQuoteVariation(this.props.quoteId, reqQuote).then((response) => {
            if (response.success !== false) {
                this.props.getAllQuoteVariation(this.props.quoteId, reqQuote)
            }
        }).catch((response) => {
            if (response.success === false || response.error) {
                this.setState({
                    addQuotePopupError: true,
                    addQuoteError: response.error,
                })

                if (reqQuote) {
                    this.setState({ requestQuote: false })
                }

            }
        })
    }

    render() {
        let step05
        if (this.props.editRenewal) {
            step05 = this.props.renewalStep05
        } else {
            step05 = this.props.step05
        }

        const { requestQuote } = this.state
        let _checkRequest = false
        this.props.variationsStep05(step05.response)

        const { isExperiencedBroker = false } = step05

        return (
            <div className="quote__form__group form__w100 variantion__container">

                {this.state.addQuotePopupError ? (
                    <PopUp
                        title={`Something Wrong`}
                        buttonText={`Close`}
                        action={() => this.setState({
                            addQuotePopupError: false,
                            addQuoteError: '',
                        })}
                    >
                        {(this.state.addQuoteError).toLowerCase()}
                    </ PopUp>
                ) : null}

                {(step05.response && (step05.response).length > 0) && step05.done &&
                    (step05.response).map((quote, index) => {
                        if (quote.requestQuote === true) {
                            _checkRequest = true
                        }
                        return (
                            step05.response[index].premium !== 0 ?
                                (quote.experiencedRate === null || quote.requestQuote === false) ?
                                    <Variation
                                        key={`dealer_quote_${index}`}
                                        index={_checkRequest ? index !== 0 ? (index - 1) : index : index}
                                        values={step05.response[index]}
                                        quoteId={this.props.quoteId}
                                        delQuoteVariation={this.props.delQuoteVariation}
                                        issueQuoteVariation={this.props.issueQuoteVariation}
                                        updateQuoteVariation={
                                            (this.props.editRenewal) ?
                                                this.props.updateRenewalVariation :
                                                this.props.updateQuoteVariation
                                        }
                                        bindQuoteVariation={this.props.bindQuoteVariation}
                                        inviteQuoteVariation={this.props.inviteQuoteVariation}
                                        checkSoftReferral={this.props.checkSoftReferral}
                                        renewalBindQuoteVariation={this.props.renewalBindQuoteVariation}
                                        loading={step05.loading}
                                        history={this.props.history}
                                        softReferrals={step05.softReferrals}
                                        dirtySteps={this.props.dirtySteps}
                                        editRenewal={this.props.editRenewal}
                                        totalCollection={this.props.totalCollection}
                                        checkUpdate={this.props.checkUpdate}
                                        quoteData={this.props.quoteData}
                                        checkRenewalStep02OnlyUpdate={this.props.checkRenewalStep02OnlyUpdate}
                                        checkStep04update={this.props.checkStep04update}
                                        maxCommission={get(step05, 'maxCommission', 3.5)}
                                        minCommission={get(step05, 'minCommission', 0)}
                                        maxExcession={get(step05, 'maxExcession', 2500)}
                                        minExcession={get(step05, 'minExcession', 0)}
                                        excessionDefault={get(step05, 'excessionDefault', 1)}
                                        tradeFairsLocList={this.state.tradeFairsLocList}
                                        tradeFairsLocations={this.props.tradeFairsLocations}
                                    /> :
                                    isExperiencedBroker ?
                                        <RateVariation
                                            key={`dealer_quote_${index}`}
                                            index={index}
                                            values={step05.response[index]}
                                            quoteId={this.props.quoteId}
                                            delQuoteVariation={this.props.delQuoteVariation}
                                            issueQuoteVariation={this.props.issueQuoteVariation}
                                            updateQuoteVariation={
                                                (this.props.editRenewal) ?
                                                    this.props.updateRenewalVariation :
                                                    this.props.updateQuoteVariation
                                            }
                                            bindQuoteVariation={this.props.bindQuoteVariation}
                                            inviteQuoteVariation={this.props.inviteQuoteVariation}
                                            checkSoftReferral={this.props.checkSoftReferral}
                                            renewalBindQuoteVariation={this.props.renewalBindQuoteVariation}
                                            history={this.props.history}
                                            loading={step05.loading}
                                            softReferrals={step05.softReferrals}
                                            dirtySteps={this.props.dirtySteps}
                                            editRenewal={this.props.editRenewal}
                                            reqVariation={this.reqVariation}
                                            totalCollection={this.props.totalCollection}
                                            checkUpdate={this.props.checkUpdate}
                                            editQuotes={this.props.editQuotes}
                                            quoteData={this.props.quoteData}
                                            checkRenewalStep02OnlyUpdate={this.props.checkRenewalStep02OnlyUpdate}
                                            checkStep04update={this.props.checkStep04update}
                                            maxCommission={get(step05, 'maxCommission', 3.5)}
                                            minCommission={get(step05, 'minCommission', 0)}
                                            maxExcession={get(step05, 'maxExcession', 2500)}
                                            minExcession={get(step05, 'minExcession', 0)}
                                            excessionDefault={get(step05, 'excessionDefault', 1)}
                                            tradeFairsLocList={this.state.tradeFairsLocList}
                                            tradeFairsLocations={this.props.tradeFairsLocations}
                                        /> : null

                                : <div>Loading</div>
                        )
                    }
                    )
                }

                {(isExperiencedBroker && !this.props.editRenewal && !requestQuote && !_checkRequest) ?
                    <NewRateVariation onClick={() => this.createNewVariation(true)} /> :
                    null
                }

                {(step05.response.length < (requestQuote || _checkRequest ? 4 : 3) && !this.props.editRenewal) ?
                    <NewVariation onClick={() => this.createNewVariation(false)} /> :
                    null
                }
            </div>
        )

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05d/components/VariantionContainer.tsx